import { createSlice, createEntityAdapter, nanoid } from '@reduxjs/toolkit';
import { AppState } from '@/store/store';

export type AlertType = {
  alertType: 'SUCCESS' | 'WARNING' | 'ERROR' | 'INFO';
  message: string;
  id: string;
};

const alertAdapter = createEntityAdapter<AlertType>({
  selectId: (alert) => alert.id,
});

export const alertSlice = createSlice({
  name: 'alert',
  initialState: alertAdapter.getInitialState({
    alerts: [] as AlertType[],
  }),
  reducers: {
    setAlert: (state, action) => {
      alertAdapter.addOne(state, { ...action.payload, id: nanoid() });
    },
    removeAlert: (state, action) => {
      alertAdapter.removeOne(state, action.payload);
    },
  },
});

export const { setAlert, removeAlert } = alertSlice.actions;
export const alertSelectors = alertAdapter.getSelectors<AppState>(
  (state) => state.alert
);
alertAdapter.getSelectors<AppState>((state) => state.alert);

export const { selectAll, selectById, selectIds, selectEntities } =
  alertSelectors;

export default alertSlice.reducer;
